<div
  class="modal fade show"
  id="modalVariantes"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ 'display': open ? 'block' : 'none' }"
  style="background: rgba(0, 0, 0, 0.5); z-index: 1055;"
  *ngIf="open">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      
      <!-- Cabecera del Modal -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="fas fa-cubes me-2"></i>
          Variantes de Material (Combo: {{ idPromo }})
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cerrarModal()"></button>
      </div>

      <!-- Cuerpo del Modal -->
      <div class="modal-body">
        
        <!-- Info del Material Principal -->
        <div class="card mb-3 border-info">
          <div class="card-body py-2 px-3 bg-light">
            <div class="row align-items-center">
              <div class="col-md-7">
                <small class="text-muted d-block">Material Principal del Combo</small>
                <strong>{{ bonificador?.id_material }} - {{ bonificador?.name_material }}</strong>
              </div>
              <div class="col-md-3">
                <small class="text-muted d-block">Unidad de Medida</small>
                <span class="badge bg-secondary">{{ bonificador?.id_unidad || 'UN' }}</span>
              </div>
              <div class="col-md-2 text-end">
                <small class="text-muted d-block">ID Promo</small>
                <span class="badge bg-primary">{{ idPromo }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Formulario para Agregar Nueva Variante -->
        <div class="card mb-3 p-3 border-secondary">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="card-subtitle text-muted fw-bold mb-0">
              <i class="fas fa-plus-circle text-success me-1"></i>
              Agregar Material Sustituto / Variante
            </h6>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="toggleBuscador()">
              <i class="fas" [ngClass]="mostrarBuscador ? 'fa-chevron-up' : 'fa-search'"></i>
              {{ mostrarBuscador ? 'Ocultar Buscador' : 'Buscar Material' }}
            </button>
          </div>

          <!-- Buscador Desplegable de Materiales -->
          <div *ngIf="mostrarBuscador" class="border rounded p-3 mb-3 bg-light">
            <div class="row g-2 align-items-end mb-2">
              <div class="col-12 col-md-4">
                <label class="form-label mb-1 small fw-bold">Buscar por:</label>
                <select class="form-select form-select-sm" [(ngModel)]="opcionBusqueda">
                  <option *ngFor="let opt of opcionesFiltro" [value]="opt.value">{{ opt.label }}</option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label mb-1 small fw-bold">Texto de búsqueda:</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Ej: CICLON, 130000002..."
                  [(ngModel)]="textoBusqueda"
                  (keyup.enter)="buscarMateriales(0)" />
              </div>
              <div class="col-12 col-md-2">
                <button
                  type="button"
                  class="btn btn-primary btn-sm w-100"
                  [disabled]="buscandoMateriales"
                  (click)="buscarMateriales(0)">
                  <i class="fas fa-search me-1"></i>
                  Buscar
                </button>
              </div>
            </div>

            <!-- Tabla de Resultados de Búsqueda -->
            <div class="table-responsive mt-2" style="max-height: 150px;">
              <table class="table table-sm table-hover table-bordered mb-0 bg-white">
                <thead class="table-secondary">
                  <tr>
                    <th style="width: 140px;">Código</th>
                    <th>Descripción</th>
                    <th style="width: 90px;" class="text-center">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let m of materialesEncontrados">
                    <td><strong>{{ m.idMaterial }}</strong></td>
                    <td>{{ m.dscaMaterial }}</td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-outline-success btn-sm py-0 px-2"
                        (click)="seleccionarMaterial(m)">
                        <i class="fas fa-check me-1"></i>
                        Elegir
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="materialesEncontrados.length === 0 && !buscandoMateriales">
                    <td colspan="3" class="text-center text-muted py-2 small">
                      No se encontraron materiales. Ingrese un término y presione Buscar.
                    </td>
                  </tr>
                  <tr *ngIf="buscandoMateriales">
                    <td colspan="3" class="text-center text-primary py-2 small">
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                      Buscando materiales en el catálogo...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación de Búsqueda -->
            <div class="d-flex justify-content-between align-items-center mt-2 pt-1 border-top" *ngIf="totalItems > 0">
              <small class="text-muted">Total registros: {{ totalItems }}</small>
              <div class="btn-group btn-group-sm">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  [disabled]="paginaActual === 0 || buscandoMateriales"
                  (click)="buscarMateriales(paginaActual - 1)">
                  <i class="fas fa-chevron-left"></i> Anterior
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  [disabled]="(paginaActual + 1) * pageSize >= totalItems || buscandoMateriales"
                  (click)="buscarMateriales(paginaActual + 1)">
                  Siguiente <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Material Seleccionado y Botón Guardar -->
          <div class="row align-items-center mt-1">
            <div class="col-12 col-md-8">
              <div class="d-flex align-items-center gap-2">
                <span class="fw-bold small text-muted">Seleccionado:</span>
                <span *ngIf="selectedMaterialVar" class="badge bg-light text-dark border p-2 text-truncate" style="max-width: 380px;">
                  <i class="fas fa-check-circle text-success me-1"></i>
                  {{ materialTitle }}
                </span>
                <span *ngIf="!selectedMaterialVar" class="text-muted fst-italic small">
                  Ningún material variante seleccionado aún
                </span>
              </div>
            </div>
            <div class="col-12 col-md-4 text-md-end mt-2 mt-md-0">
              <button
                type="button"
                class="btn btn-success btn-sm w-100"
                [disabled]="!selectedMaterialVar || loading"
                (click)="agregarVariante()">
                <i class="fas fa-plus me-1"></i>
                Agregar Variante
              </button>
            </div>
          </div>
        </div>

        <!-- Tabla de Variantes Registradas -->
        <h6 class="fw-bold mb-2 text-secondary">
          <i class="fas fa-list me-1"></i>
          Variantes Registradas ({{ variantes.length }})
        </h6>

        <div class="table-responsive" style="max-height: 250px;">
          <table class="table table-sm table-striped table-hover align-middle border">
            <thead class="table-dark">
              <tr>
                <th style="width: 50px;">#</th>
                <th style="width: 140px;">Cód. Variante</th>
                <th>Descripción Material Variante</th>
                <th style="width: 80px;" class="text-center">Unidad</th>
                <th style="width: 80px;" class="text-center">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of variantes; let i = index">
                <td>{{ i + 1 }}</td>
                <td><strong class="text-primary">{{ v.id_material_var }}</strong></td>
                <td>{{ v.name_material_var || '-' }}</td>
                <td class="text-center"><span class="badge bg-secondary">{{ v.id_unidad }}</span></td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-sm p-1"
                    title="Eliminar variante"
                    (click)="eliminarVariante(v)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="variantes.length === 0 && !loading">
                <td colspan="5" class="text-center text-muted py-3">
                  <i class="fas fa-box-open me-1"></i>
                  No existen variantes configuradas para este material en la promoción.
                </td>
              </tr>
              <tr *ngIf="loading">
                <td colspan="5" class="text-center text-primary py-3">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Cargando variantes...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <!-- Pie del Modal -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cerrarModal()">
          <i class="fas fa-times me-1"></i>
          Cerrar
        </button>
      </div>

    </div>
  </div>
</div>
